// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Printable Route Timetable (M1) — scope printing to the poster only.
   Classic visibility-toggle so only .poster-print-root reaches the page,
   regardless of the MUI Dialog portal/backdrop it lives in. */
@media print {
  body * {
    visibility: hidden !important;
  }
  .poster-print-root,
  .poster-print-root * {
    visibility: visible !important;
  }
  .poster-print-root {
    position: fixed !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    background: #fff !important;
  }
  /* The on-screen preview scales to fit the dialog (via zoom); print at true size. */
  .poster-print-root .poster-scale {
    zoom: 1 !important;
    transform: none !important;
    width: auto !important;
    height: auto !important;
  }
  /* Let the dialog that hosts the poster overflow instead of clipping it. */
  .MuiDialog-container,
  .MuiDialog-paper,
  .MuiDialogContent-root {
    overflow: visible !important;
    max-height: none !important;
    box-shadow: none !important;
  }
  /* ponytail: A4 portrait fixed for M1; A3/A2 + orientation land in M2. */
  @page {
    size: A4 portrait;
    margin: 8mm;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/fixedRoutes/poster/posterPrint.css"],"names":[],"mappings":"AAAA;;8DAE8D;AAC9D;EACE;IACE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA,mFAAmF;EACnF;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;EACzB;EACA,0EAA0E;EAC1E;;;IAGE,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;EAC7B;EACA,wEAAwE;EACxE;IACE,iBAAiB;IACjB,WAAW;EACb;AACF","sourcesContent":["/* Printable Route Timetable (M1) — scope printing to the poster only.\n   Classic visibility-toggle so only .poster-print-root reaches the page,\n   regardless of the MUI Dialog portal/backdrop it lives in. */\n@media print {\n  body * {\n    visibility: hidden !important;\n  }\n  .poster-print-root,\n  .poster-print-root * {\n    visibility: visible !important;\n  }\n  .poster-print-root {\n    position: fixed !important;\n    left: 0 !important;\n    top: 0 !important;\n    width: 100% !important;\n    height: auto !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    overflow: visible !important;\n    background: #fff !important;\n  }\n  /* The on-screen preview scales to fit the dialog (via zoom); print at true size. */\n  .poster-print-root .poster-scale {\n    zoom: 1 !important;\n    transform: none !important;\n    width: auto !important;\n    height: auto !important;\n  }\n  /* Let the dialog that hosts the poster overflow instead of clipping it. */\n  .MuiDialog-container,\n  .MuiDialog-paper,\n  .MuiDialogContent-root {\n    overflow: visible !important;\n    max-height: none !important;\n    box-shadow: none !important;\n  }\n  /* ponytail: A4 portrait fixed for M1; A3/A2 + orientation land in M2. */\n  @page {\n    size: A4 portrait;\n    margin: 8mm;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
